<template>
    <article class="full-screen-image" :class="getModuleThemeClass()">
        <span v-if="item.Preline != ''" class="full-screen-image__preline">{{ item.Preline }}</span>
        <h2 v-if="item.Headline != ''" class="full-screen-image__headline">{{ item.Headline }}</h2>
        <span v-if="item.Postline != ''" class="full-screen-image__postline">{{ item.Postline }}</span>
        <image-component v-if="item.Image.Image.Path" :image="item.Image" module-name="full-screen-image" :sizes="getSizeParameters()" />
    </article>
</template>
<script>
import ImageComponent from '../components/image-component.vue';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'FullScreenImage',
    components: {
        ImageComponent
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        modalHasNavigation: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getSizeParameters() {
            return [
                {
                    breakpoint: '1920',
                    width: this.modalHasNavigation ? '1232' : '1800',
                    height: this.modalHasNavigation ? '693' : '1012',
                    compression: 100
                },
                {
                    breakpoint: '992',
                    width: this.modalHasNavigation ? '1195' : '1727',
                    height: this.modalHasNavigation ? '672' : '972',
                    compression: 100
                },
                {
                    breakpoint: '480',
                    width: this.modalHasNavigation ? '595' : '892',
                    height: this.modalHasNavigation ? '335' : '502',
                    compression: 100
                },
                {
                    default: true,
                    width: '459',
                    height: '459',
                    compression: 100
                }
            ];
        },
    }
};
</script>
